import { CustomButton, SearchBar, searchDateFormat } from "components/form";
import React, { useEffect, useState } from "react";
import { IoArrowDownSharp } from "react-icons/io5";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { dateFormatWithTime } from "utils/dateFormat";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import useDebounce from "common/UseDebounce";
import { getLocalStorage, setLocalStorage } from "config/config";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { DatePicker } from "common/InputForm";
import { toast } from "sonner";
import { donationListApi } from "services/donation";
import { setJwtToken } from "config/axiosInstance";
import axios from "axios";
const DonationManagement = () => {
  const [donationList, setDonationList] = useState([]);
  const [search, setSearch] = useState(
    getLocalStorage("donationList", "search") || ""
  );
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [total, setTotal] = useState(null);
  const activePage = +searchParams.get("page") || 1;
  let searchStartDate = searchParams.get("startDate") || "";
  let searchEndDate = searchParams.get("endDate") || "";
  const limit = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const [loader, onShow, onHide] = useFullPageLoader();
  const [buttonLoaderFile, setButtonLoaderFile] = useButtonLoader("Export");

  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };

  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("startDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("endDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");
    setSearch("");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    setSearchParams(searchParams);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/

  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  // donation list handler
  const donationListHandler = async (
    page = activePage,
    limit = "10",
    search = debouncedValue,
    sortField = fieldName || "createdAt",
    sortDirection = direaction,
    startDate = searchStartDate,
    endDate = searchEndDate,
    donationType = statusValue
  ) => {
    try {
      onShow();
      const res = await donationListApi({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        startDate,
        endDate,
        donationType,
      });
      if (res?.data?.status === 200) {
        setTotal(res.data.data.total);
        setDonationList(res.data?.data?.data);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "donationList");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    donationListHandler();
  }, [
    searchParams,
    debouncedValue,
    fieldName,
    direaction,
    searchStartDate,
    searchEndDate,
    statusValue,
  ]);

  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);
  useEffect(() => {
    setLocalStorage("donationList", "search", search);
  }, [search]);
  const url = `${process.env.REACT_APP_API_URL}export/donation`;
  // export teacher
  const downloadFile = async (url, fileName, params = {}) => {
    try {
      setButtonLoaderFile(true);
      const { headers } = setJwtToken();
      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setButtonLoaderFile(false);
    }
  };
  return (
    <>
      <div className="student_management">
        <div className="dashboard_title">
          <h3>Donation Management</h3>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search..."}
              onChange={(e) =>{ setSearch(e.target.value)
                searchParams.delete("page");
                setSearchParams(searchParams);

                }
              }              value={search}
            />
            <div className="d-flex align-items-center">
              <select
                className="input form-control"
                value={statusValue}
                onChange={handleStatus}
              >
                <option value={""}>Select Donation Type</option>
                <option value="8OG">8OG</option>
                <option value="Anonymous">Anonymous</option>
              </select>

              <DatePicker
                name="startDate"
                selected={searchStartDate}
                placeholder="Start Date"
                onChange={(date) => handleStartDate(date)}
                maxDate={searchEndDate}
              />
              <DatePicker
                name="endDate"
                placeholder="End Date"
                selected={searchEndDate}
                onChange={(date) => handleEndDate(date)}
                minDate={searchStartDate}
              />

              <CustomButton
                type="button"
                className="button me-2"
                ref={buttonLoaderFile}
                onClick={() => downloadFile(url)}
              >
                Export
              </CustomButton>

              <CustomButton onClick={resetFilterHandler}>
              Reset              </CustomButton>
            </div>
          </div>
          <div className="button_section">
            <div className="d-flex"></div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap">Receipt No.</th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("donationType")}
                    >
                      Donation Type{" "}
                      {fieldName === "donationType"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th className="nowrap" onClick={() => handleSort("amount")}>
                      Donation Amount{" "}
                      {fieldName === "amount"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("transectionId")}
                    >
                      Transaction ID{" "}
                      {fieldName === "transectionId"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("platformType")}
                    >
                      Platform{" "}
                      {fieldName === "platformType"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("createdAt")}
                    >
                      Date & Time{" "}
                      {fieldName === "createdAt"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("donationType")}
                    >
                      No. of Times{" "}
                      {fieldName === "donationType"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("fullName")}
                    >
                      Full Name{" "}
                      {fieldName === "fullName"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th className="nowrap" onClick={() => handleSort("phone")}>
                      Phone No.{" "}
                      {fieldName === "phone"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th className="nowrap" onClick={() => handleSort("email")}>
                      Email{" "}
                      {fieldName === "email"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("panAadharPassport")}
                    >
                      Pan/Aadhar/Passport/Driving License{" "}
                      {fieldName === "panAadharPassport"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("pincode")}
                    >
                      Pincode{" "}
                      {fieldName === "pincode"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("address")}
                    >
                      Address{" "}
                      {fieldName === "address"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                    <th
                      className="nowrap"
                      onClick={() => handleSort("donationType")}
                    >
                      Documents Sent?{" "}
                      {fieldName === "donationType"
                        ? direaction === "ASC"
                          ? "↑"
                          : "↓"
                        : "↓"}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {donationList && donationList.length > 0 ? (
                    donationList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          <td className="nowrap">{index + 1}</td>

                          <td className="nowrap">{data?.donationType}</td>
                          <td className="nowrap">{data?.amount}</td>
                          <td className="nowrap">{data?.transectionId}</td>
                          <td>{data?.platformType || "---"}</td>

                          <td className="nowrap">
                            {" "}
                            {dateFormatWithTime(data?.createdAt)}
                          </td>
                          <td>{data?.donationCount || "---"}</td>
                          <td>{data?.fullName || "---"}</td>
                          <td>{data?.phone || "---"}</td>
                          <td>{data?.email || "---"}</td>
                          <td>{data?.panAadharPassport || "---"}</td>
                          <td>{data?.pincode || "---"}</td>
                          <td>{data?.address || "---"}</td>
                          <td>{data?.donationType === "8OG" ? "Yes" : "No"}  </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"Donation data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DonationManagement;
